import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="infinite-scroll"
export default class extends Controller {
  static targets = ["entries", "spinner"]
  static values = {
    url: String,
    page: Number
  }

  connect() {
    this.scroll = this.scroll.bind(this)
    this.loadingMore = false
    this.hasMore = true

    window.addEventListener("scroll", this.scroll)
  }

  disconnect() {
    window.removeEventListener("scroll", this.scroll)
  }

  scroll() {
    // Skip if already loading or no more pages
    if (this.loadingMore || !this.hasMore) return

    // Check if user scrolled near bottom (800px before end)
    const scrollPosition = window.scrollY + window.innerHeight
    const documentHeight = document.documentElement.scrollHeight

    if (scrollPosition >= documentHeight - 800) {
      this.loadMore()
    }
  }

  async loadMore() {
    if (this.loadingMore || !this.hasMore) return

    this.loadingMore = true
    this.showSpinner()

    const nextPage = this.pageValue + 1
    const url = new URL(this.urlValue, window.location.origin)
    url.searchParams.set("page", nextPage)

    try {
      const response = await fetch(url, {
        headers: {
          Accept: "text/vnd.turbo-stream.html"
        }
      })

      if (response.ok) {
        const html = await response.text()

        // Check if response is empty (no more pages)
        if (html.trim().length === 0) {
          this.hasMore = false
        } else {
          // Let Turbo handle the response
          Turbo.renderStreamMessage(html)
          this.pageValue = nextPage
        }
      } else {
        this.hasMore = false
      }
    } catch (error) {
      console.error("Error loading more authors:", error)
      this.hasMore = false
    } finally {
      this.hideSpinner()
      this.loadingMore = false
    }
  }

  showSpinner() {
    if (this.hasSpinnerTarget) {
      this.spinnerTarget.classList.remove("hidden")
    }
  }

  hideSpinner() {
    if (this.hasSpinnerTarget) {
      this.spinnerTarget.classList.add("hidden")
    }
  }
}
